export const ColorScale = {
    magma: [
        '#fcfdbf',
        '#fdda9c',
        '#feb67c',
        '#fc9065',
        '#f66c5c',
        '#e34e65',
        '#c53c74',
        '#a6317d',
        '#862781',
        '#671b80',
        '#491078',
        '#271258',
        '#0d0a29',
        '#000004',
    ],
    bathymetry: [
        '#fdfecc',
        '#dcf2bc',
        '#bbe6ac',
        '#78cea3',
        '#67bea3',
        '#55aea3',
        '#488e9e',
        '#447e9b',
        '#3f6e97',
        '#405d91',
        '#404c8b',
        '#3b315a',
        '#322643',
        '#281a2c',
    ],
    bone: [
        '#ffffff',
        '#e2eded',
        '#c6dada',
        '#a9c8c8',
        '#98b1b7',
        '#879aa6',
        '#768296',
        '#656b85',
        '#545474',
        '#43435d',
        '#323246',
        '#22222e',
        '#111117',
        '#000000',
    ],
    velocityBlue: [
        '#fefbe6',
        '#e5ecdd',
        '#cbddd3',
        '#95c4bd',
        '#76b9b7',
        '#57adb0',
        '#3290a9',
        '#2981a6',
        '#1f71a2',
        '#1e619f',
        '#1d519c',
        '#233474',
        '#1a2a5a',
        '#112040',
    ],
    viridis: [
        '#fde725',
        '#cde11d',
        '#98d83e',
        '#67cc5c',
        '#40bd72',
        '#25ac82',
        '#1f998a',
        '#24878e',
        '#2b748e',
        '#34618d',
        '#3d4d8a',
        '#453581',
        '#481c6e',
        '#440154',
    ],
    copper: [
        '#ffc77f',
        '#ffba77',
        '#ffad6e',
        '#ffa066',
        '#e6905c',
        '#cc8052',
        '#b37047',
        '#99603d',
        '#805033',
        '#664029',
        '#4d301f',
        '#332014',
        '#1a100a',
        '#000000',
    ],
};
